import React from 'react';
import Intl from 'src/components/Intl';

const questionnaireSelection = {
  // Reason For Purchase
  top3CriteriaToPurchase: {
    id: 'top3CriteriaToPurchase',
    title:
      'PLEASE IDENTIFY YOUR TOP 3 CRITERIA IN DECIDING TO PURCHASE AT THE AMAZING BRENTWOOD (SELECT 3): ',
    mustMax: 3,
    maxSelect: 3,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'Community',
      },
      {
        value: 'Developer/Builder',
      },
      {
        value: 'Friend or Family Referral',
      },
      {
        value: 'Home Design',
      },
      {
        value: 'Location',
      },
      {
        value: 'Opportunity for Long-Term Appreciation',
      },
      {
        value: 'Price',
      },
      {
        value: 'Retail/Commercial Amenities',
      },
      {
        value: 'Residential Amenities',
      },
      {
        value: 'Realtor Referral',
      },
      {
        value: 'SkyTrain Proximity',
      },
    ],
  },
  top3FeaturesToPurchase: {
    id: 'top3FeaturesToPurchase',
    title:
      'PLEASE IDENTIFY YOUR TOP 3 MOST IMPORTANT HOME FEATURES IN DECIDING TO PURCHASE (SELECT 3): ',
    mustMax: true,
    maxSelect: 3,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'Air Conditioning',
      },
      {
        value: 'Balcony Size',
      },
      {
        value: 'Home Feature',
      },
      {
        value: 'Interior Finishing',
      },
      {
        value: 'Kitchen',
      },
      {
        value: 'Layout',
      },
      {
        value: 'Luxury Appliances',
      },
      {
        value: 'Multi-purpose Kitchen Island',
      },
      {
        value: 'Side-By-Side Laundry',
      },
      {
        value: 'Workspace',
      },
    ],
  },
  reasonToPurchase: {
    id: 'reasonToPurchase',
    title: 'REASON FOR PURCHASE:',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'For Family',
      },
      {
        value: 'Investment (Assignment or Sale at Completion)',
      },
      {
        value: 'Investment (Rental)',
      },
      {
        value: 'Investment (Other)', // changed from "Investment (Other)"
      },
      {
        value: 'Principal Residence (Downsizing)',
      },
      {
        value: 'Principal Residence (Upsizing)',
      },
      {
        value: 'Principal Residence (Second Home, Other)',
      },
    ],
  },
  // Lifestyl
  top3Groceries: {
    id: 'top3Groceries',
    title: 'WHERE ARE THE TOP 3 PLACES YOU SHOP FOR GROCERIES?',
    mustMax: true,
    maxSelect: 3,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'City Market',
      },
      {
        value: 'T&T',
      },
      {
        value: 'Safeway',
      },
      {
        value: 'Save-on-Foods',
      },
      {
        value: 'Sungiven Foods',
      },
      {
        value: 'Superstore',
      },
      {
        value: 'Urban Fare',
      },
    ],
  },
  groceriesDeliverFrequency: {
    id: 'groceriesDeliverFrequency',
    title: 'HOW OFTEN DO YOU HAVE YOUR GROCERIES DELIVERED?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Daily',
      },
      {
        value: '2-3 times per week',
      },
      {
        value: 'Weekly',
      },
      {
        value: 'Monthly',
      },
      {
        value: 'Never',
      },
    ],
  },
  dineOutFrequency: {
    id: 'dineOutFrequency',
    title: 'HOW OFTEN DO YOU DINE OUT?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Daily',
      },
      {
        value: '2-3 times per week',
      },
      {
        value: 'Weekly',
      },
      {
        value: 'Monthly',
      },
      {
        value: 'Never',
      },
    ],
  },
  top3RestaurantType: {
    id: 'top3RestaurantType',
    title:
      'PLEASE IDENTIFY THE TOP 3 TYPES OF RESTAURANTS YOU WOULD LIKE TO HAVE AT THE AMAZING BRENTWOOD:',
    mustMax: true,
    maxSelect: 3,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'Chinese',
      },
      {
        value: 'Japanese',
      },
      {
        value: 'Mexican',
      },
      {
        value: 'Italian',
      },
      {
        value: 'Indian',
      },
      {
        value: 'Western/Canadian',
      },
      {
        value: 'Vegan',
      },
      {
        value: 'Breakfast',
      },
      {
        value: 'Bakery',
      },
    ],
  },
  deliveryFrequency: {
    id: 'deliveryFrequency',
    title: 'HOW OFTEN DO YOU ORDER MEAL DELIVERY?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Daily',
      },
      {
        value: '2-3 times per week',
      },
      {
        value: 'Weekly',
      },
      {
        value: 'Monthly',
      },
      {
        value: 'Never',
      },
    ],
  },
  primaryTransportation: {
    id: 'primaryTransportation',
    title: 'WHAT IS YOUR PRIMARY MODE OF TRANSPORTATION?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Car/Automobile',
      },
      {
        value: 'Bike',
      },
      {
        value: 'Walking',
      },
      {
        value: 'Transit (e.g., SkyTrain, bus, SeaBus, etc.)',
      },
      {
        value: 'Car Share Program (e.g., Evo, Modo, Zipcar, etc.)',
      },
    ],
  },

  cityOfEmployment: {
    id: 'cityOfEmployment',
    title: 'WHAT CITY DO YOU WORK IN?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Vancouver',
      },
      {
        value: 'Burnaby',
      },
      {
        value: 'Coquitlam',
      },
      {
        value: 'New Westminster',
      },
      {
        value: 'North Vancouver',
      },
      {
        value: 'Port Moody',
      },
      {
        value: 'Richmond',
      },
      {
        value: 'Surrey',
      },
      {
        value: 'Work from Home',
      },
    ],
  },
  technologyUpToDate: {
    id: 'technologyUpToDate',
    title:
      'HOW IMPORTANT IS IT TO HAVE THE MOST UP-TO-DATE TECHNOLOGY IN YOUR HOME?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Very Important',
      },
      {
        value: 'Somewhat Important',
      },
      {
        value: 'Not Important',
      },
    ],
  },
  patioFrequency: {
    id: 'patioFrequency',
    title: 'HOW OFTEN DO YOU USE YOUR CURRENT PATIO?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Daily',
      },
      {
        value: '2-3 times per week',
      },
      {
        value: 'Weekly',
      },
      {
        value: 'Monthly',
      },
      {
        value: 'Year round (weather permitting)',
      },
      {
        value: 'Never',
      },
      {
        value: 'I don’t have a patio',
      },
    ],
  },
  patioUsage: {
    id: 'patioUsage',
    title: 'WHAT DO YOU USE YOUR PATIO FOR? (SELECT ALL THAT APPLY)',
    mustMax: false,
    maxSelect: 0,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'Extension of living space ',
      },
      {
        value: 'Socializing',
      },
      {
        value: 'BBQ',
      },
      {
        value: 'Storage',
      },
    ],
  },
  storageUsage: {
    id: 'storageUsage',
    title:
      'If you have a storage locker, what do you use it for? (SELECT ALL THAT APPLY)',
    mustMax: false,
    maxSelect: 0,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'Appliances',
      },
      {
        value: 'Sports Equipment',
      },
      {
        value: 'Suitcases',
      },
      {
        value: 'Seasonal Decorations ',
      },
      {
        value: "I don't have a storage locker",
        afterOther: true,
      },
    ],
  },
  conciergeImportant: {
    id: 'conciergeImportant',
    title: 'HOW IMPORTANT IS IT TO HAVE A CONCIERGE IN YOUR BUILDING?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Very Important',
      },
      {
        value: 'Somewhat Important',
      },
      {
        value: 'Not Important',
      },
    ],
  },
  withoutParking: {
    id: 'withoutParking',
    title: 'WOULD YOU PURCHASE A HOME WITHOUT A PARKING STALL?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  discountWithoutParking: {
    id: 'discountWithoutParking',
    title:
      'HOW MUCH OF A HOME DISCOUNT WOULD YOU CONSIDER TO PURCHASE A HOME WITHOUT PARKING?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: '$20,000 Discount',
      },
      {
        value: '$30,000 Discount',
      },
      {
        value: '$40,000 Discount',
      },
      {
        value: '$50,000 Discount',
      },
      {
        value: '+$60,000 Discount',
      },
    ],
  },
  top3Social: {
    id: 'top3Social',
    title: 'WHICH SOCIAL PLATFORM DO YOU USE MOST? SELECT YOUR TOP 3:',
    mustMax: true,
    maxSelect: 3,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'Facebook',
      },
      {
        value: 'WeChat',
      },
      {
        value: 'TikTok',
      },
      {
        value: 'Instagram',
      },
      {
        value: 'Twitter',
      },
      {
        value: 'SnapChat',
      },
      {
        value: 'YouTube',
      },
      {
        value: 'Weibo',
      },
      {
        value: 'KakaoTalk',
      },
    ],
  },
  rentalMarketImpact: {
    id: 'rentalMarketImpact',
    title:
      'HAS THE RENTAL MARKET IMPACTED YOUR DECISION TO MAKE THIS INVESTMENT?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  rentAtAmazing: {
    id: 'rentAtAmazing',
    title: 'HAVE YOU RENTED AT THE AMAZING BRENTWOOD IN THE PAST?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  ownAtAmazing: {
    id: 'ownAtAmazing',
    title: 'DO YOU CURRENTLY OWN A HOME AT THE AMAZING BRENTWOOD?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  primarilyPurcahseFor: {
    id: 'primarilyPurcahseFor',
    title:
      'IS THIS PURCHASE PRIMARILY A FINANCIAL INVESTMENT OR A LIFESTYLE INVESTMENT?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Financial Investment',
      },
      {
        value: 'Lifestyle Investment ',
      },
    ],
  },
  numberOfInvestmentProperties: {
    id: 'numberOfInvestmentProperties',
    title: 'HOW MANY INVESTMENT PROPERTIES DO YOU OWN?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: '1-2 properties',
      },
      {
        value: '3-4 properties',
      },
      {
        value: '+5 properties',
      },
      {
        value: 'None',
      },
    ],
  },
  primarilyPortfolio: {
    id: 'primarilyPortfolio',
    title:
      'WHERE DO YOU PRIMARILY INVEST TO BUILD YOUR WEALTH PORTFOLIO? Please select your top 3:',
    mustMax: true,
    maxSelect: 3,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'Stocks',
      },
      {
        value: 'Real Estate',
      },
      {
        value: 'Bonds',
      },
      {
        value: 'Savings',
      },
      {
        value: 'Cryptocurrency (Blockchain, NFTs, etc.)',
      },
    ],
  },
  mortgageHome: {
    id: 'mortgageHome',
    title:
      'WHEN YOUR HOME IS COMPLETE, DO YOU INTEND TO TAKE OUT A MORTGAGE TO FINANCE THE HOME?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  downpaymentSource: {
    id: 'downpaymentSource',
    title: 'WHAT IS THE SOURCE OF YOUR DOWN PAYMENT?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Savings',
      },
      {
        value: 'Family',
      },
      {
        value: 'Loans',
      },
      {
        value: 'Other Assets',
      },
    ],
  },
  anotherHomeIn12Month: {
    id: 'anotherHomeIn12Month',
    title:
      'ARE YOU PLANNING TO MAKE ANOTHER HOME PURCHASE IN THE NEXT 12 MONTHS?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  completionLengthBenefit: {
    id: 'completionLengthBenefit',
    title:
      'WOULD YOU CONSIDER THE LENGTH OF COMPLETION TIME (5-6 YEARS) A BENEFIT?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  top3ResaleVSPresale: {
    id: 'top3ResaleVSPresale',
    title: 'WHY DID YOU CHOOSE PRE-SALE OVER RESALE? PLEASE SELECT 3:',
    mustMax: true,
    maxSelect: 3,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'Timing Better for Deposits',
      },
      {
        value: 'Timing Better for Lifestyle',
      },
      {
        value: 'Deposit Leverage Opportunity',
      },
      {
        value: 'No comparable options in resale market',
      },
      {
        value: 'Prefer new',
      },
      {
        value: 'Specifically wanted The Amazing Brentwood',
      },
      {
        value: 'Amenity Offering',
      },
      {
        value: 'Smoother Sales Process (No bidding)',
      },
    ],
  },
  firstPurcahse: {
    id: 'firstPurcahse',
    title: 'IS THIS YOUR FIRST HOME PURCHASE?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  purchasedBurnaby: {
    id: 'purchasedBurnaby',
    title: 'HAVE YOU PURCHASED IN BURNABY BEFORE?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
    ],
  },
  householdIncome: {
    id: 'householdIncome',
    title: 'WHAT IS YOUR HOUSEHOLD INCOME?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Less than $100,000',
      },
      {
        value: '$100,000 - $199,999',
      },
      { value: '$200,000+' },
      {
        value: 'Prefer not to answer',
      },
    ],
  },
  typeOfHomeCurrent: {
    id: 'typeOfHomeCurrent',
    title: 'WHAT TYPE OF HOME DO YOU CURRENTLY LIVE IN?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Condominium',
      },
      {
        value: 'Townhouse',
      },
      {
        value: 'Single Family Home',
      },
    ],
  },
  primarilyFinancialInstitution: {
    id: 'primarilyFinancialInstitution',
    title: 'WHICH FINANCIAL INSTITUTION DO YOU PRIMARILY BANK WITH?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'CIBC',
      },
      {
        value: 'RBC',
      },
      {
        value: 'TD',
      },
      {
        value: 'Bank of Montreal',
      },
      {
        value: 'Scotiabank',
      },
      {
        value: 'Credit Union',
      },
      {
        value: 'HSBC',
      },
    ],
  },
  languageAtHome: {
    id: 'languageAtHome',
    title: 'WHAT LANGUAGE IS MOST SPOKEN IN YOUR HOME?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'English ',
      },
      {
        value: 'Farsi ',
      },
      {
        value: 'French ',
      },
      {
        value: 'Italian ',
      },
      {
        value: 'Punjabi ',
      },
      {
        value: 'Cantonese ',
      },
      {
        value: 'Hindi ',
      },
      {
        value: 'Mandarin ',
      },
      {
        value: 'Korean ',
      },
    ],
  },
  childrenCount: {
    id: 'childrenCount',
    title: 'DO YOU HAVE CHILDREN? IF YES, HOW MANY?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Planning to have children ',
      },
      {
        value: '1',
      },
      {
        value: '2',
      },
      {
        value: '3',
      },
      {
        value: '4+',
      },
      {
        value: 'No',
      },
    ],
  },
  childPlayAmenities: {
    id: 'childPlayAmenities',
    title:
      'HOW IMPORTANT IS IT TO HAVE CHILDREN PLAY AMENITIES IN YOUR BUILDING?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Very Important',
      },
      {
        value: 'Somewhat Important',
      },
      {
        value: 'Not Important',
      },
    ],
  },
  projectHeard: {
    id: 'projectHeard',
    title:
      'What other SHAPE projects have you heard of? (Select all that apply)',
    mustMax: false,
    maxSelect: 0,
    checkbox: true,
    radio: false,
    options: [
      {
        value: 'The City of Lougheed',
      },
      {
        value: 'RC at CF Richmond Centre',
      },
      {
        value: 'I have not heard of other SHAPE projects',
      },
    ],
  },
  shapeQaulityPerception: {
    id: 'shapeQaulityPerception',
    title:
      'What is your perception of SHAPE’S ability to deliver a quality home at completion?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Very Good',
      },
      {
        value: 'Good',
      },
      {
        value: 'Somewhat Good',
      },
      {
        value: 'Somewhat Bad',
      },
      {
        value: 'Bad',
      },
      {
        value: 'Very Bad',
      },
    ],
  },
  shapeReputationImpact: {
    id: 'shapeReputationImpact',
    title: 'Did SHAPE’S reputation impact your decision to purchase a home?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Yes',
      },
      {
        value: 'No',
      },
      {
        value: 'Was not aware of SHAPE before The Amazing Brentwood',
      },
    ],
  },
  frenquencyWorkFromHome: {
    id: 'frenquencyWorkFromHome',
    title: 'HOW MANY TIMES A WEEK DO YOU WORK FROM HOME?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Once a week',
      },
      {
        value: '2-3 times per week',
      },
      {
        value: '4+ times per week',
      },
      {
        value: 'Never',
      },
    ],
  },
  workpaceAtHome: {
    id: 'workpaceAtHome',
    title: 'HOW IMPORTANT IS IT FOR YOU TO HAVE A WORKSPACE AT HOME?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Very Important',
      },
      {
        value: 'Somewhat Important',
      },
      {
        value: 'Not Important',
      },
    ],
  },
  officeAtHome: {
    id: 'officeAtHome',
    title:
      'HOW IMPORTANT IS IT FOR YOU TO HAVE AN OFFICE (DEDICATED ROOM) IN YOUR HOME?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Very Important',
      },
      {
        value: 'Somewhat Important',
      },
      {
        value: 'Not Important',
      },
    ],
  },
  coWorkingAtHome: {
    id: 'coWorkingAtHome',
    title:
      'HOW IMPORTANT IS IT FOR YOU TO HAVE CO-WORKING SPACE AS A BUILDING AMENITY?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Very Important',
      },
      {
        value: 'Somewhat Important',
      },
      {
        value: 'Not Important',
      },
    ],
  },
  purchaseExperience: {
    id: 'purchaseExperience',
    title:
      'HOW WAS THE PROCESS OF PURCHASING YOUR HOME AT THE AMAZING BRENTWOOD?',
    mustMax: false,
    maxSelect: 1,
    checkbox: false,
    radio: true,
    options: [
      {
        value: 'Very Good',
      },
      {
        value: 'Good',
      },
      {
        value: 'Somewhat Good',
      },
      {
        value: 'Somewhat Bad',
      },
      {
        value: 'Bad',
      },
      {
        value: 'Very Bad',
      },
    ],
  },
};

export default questionnaireSelection;
